import FastMarquee from "react-fast-marquee";
import { useLanguage } from "@/i18n";

const Marquee = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 border-b border-white/10 overflow-hidden" data-testid="marquee-section">
      <FastMarquee speed={28} gradient={false}>
        {t.marquee.map((phrase, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className={`font-display font-semibold text-5xl md:text-8xl tracking-tight mx-6 md:mx-10 ${i % 2 === 0 ? "text-outline" : "text-thermal"}`}>
              {phrase}
            </span>
            <span className="font-mono text-white/25 text-2xl md:text-4xl">//</span>
          </span>
        ))}
      </FastMarquee>
    </section>
  );
};

export default Marquee;
